import { getSharedStore, setSharedStore } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/stores/shared.js?1733898722584';

import { writable, readable } from 'svelte/store';

export const price_request_name = 'price_request';

function createPriceRequest() {
    // always empty on server
    if (false) {
        return readable([]);
    }
    const store = getSharedStore(price_request_name);
    if (store) {
        return store;
    }
    return setSharedStore(price_request_name, writable([]));
}

export const price_request = createPriceRequest();
